import { addDataLayerEntry, Events } from '@printdeal/data-layer-manager';
import { windowPresent, LS_KEYS, getFromLocalStorage } from '../window';
import { PrintdealAuthTokenPayload } from '../auth';

const AuthEvents = {
  UserDataAdded: 'userDataAdded',
  UserDataRemoved: 'userDataRemoved',
};

class AuthDataLayerHelper {
  /**
   * @param location For example: 'Checkout'
   */
  static dispatchLoginViewDataLayerEvent(location: string) {
    // GA4
    addDataLayerEntry('view_login', {
      location,
    });

    // GA3
    addDataLayerEntry('gaEvent', {
      gaEvent: {
        eventCategory: location,
        eventAction: 'loginView',
        eventNonInteraction: true,
      },
    });
  }

  /**
   * GA4 version of `dispatchDataLayerEventOnLogin`, which has different parameters and needs to be called
   * from a different place in the code to be able to access this data.
   * @param location For example: 'Checkout'
   * @param userId
   * @param eventLabel
   */
  static dispatchLoginSuccessDataLayerEvent(location: string, userId: string, eventLabel?: string) {
    // GA4
    addDataLayerEntry('login', {
      location,
      user_id: userId,
      eventLabel,
    });

    // GA3
    addDataLayerEntry('gaEvent', {
      gaEvent: {
        eventCategory: location,
        eventAction: 'loginView',
        eventNonInteraction: true,
        eventLabel,
      },
    });
  }

  /**
   * GA3 version of `dispatchLoginSuccessDataLayerEvent`.
   */
  static dispatchDataLayerEventOnLogin(decodedAuthToken: PrintdealAuthTokenPayload, isOnChangeRoute = false) {
    if (!isOnChangeRoute && getFromLocalStorage(LS_KEYS.CUSTOMER_NUMBER)) {
      // Prevent double userDataAdded entry
      return;
    }

    addDataLayerEntry(AuthEvents.UserDataAdded, {
      userId: decodedAuthToken.account?.id,
      userEmail: decodedAuthToken.account?.email,
    });
  }

  /**
   * User has logged out event
   */
  static dispatchDataLayerEventOnLogout() {
    addDataLayerEntry(AuthEvents.UserDataRemoved, {
      userId: undefined,
      userEmail: undefined,
    });
  }

  static enableLoginEventOnRouteUpdate() {
    return windowPresent
      && (!window.dataLayer
        || window.dataLayer.length === 0
        || (window.dataLayer.length < 20 // 20 events without a single pageView? No way!
          && !window.dataLayer.find(
            (dataLayerEvent) => dataLayerEvent.event && dataLayerEvent.event === Events.PageView,
          )));
  }

  /**
   * User authenticated on initial load
   */
  static dispatchDataLayerEventOnAuthenticate(decodedAuthToken: PrintdealAuthTokenPayload) {
    addDataLayerEntry(AuthEvents.UserDataAdded, {
      userId: decodedAuthToken.account?.id,
      userEmail: decodedAuthToken.account?.email,
    });
  }
}

export {
  AuthDataLayerHelper,
};
